module.exports = __webpack_public_path__ + "static/img/activity-btn.855f28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity-btn.png
// module id = hobA
// module chunks = 1